/* FLOWMIX free gift: Prep Fruit Bags with any blender (automatic discount "Free gift · Prep Fruit Bags with any blender"). */
(function () {
  var BLENDERS = [10320510877758, 15428519723070]; // Portable Blender, Mega Blender
  var GIFT_PRODUCT = 10319813443646; // Prep Fruit Bags
  var GIFT_VARIANT = 50533982404670; // Clear
  var root = document.documentElement;
  var he = (root.lang || '').indexOf('he') === 0;
  var prefix = he ? '/he' : '';
  var T = he ? {
    unlocked: 'מתנה עם הבלנדר: שקיות פירות Prep בחינם',
    add: 'הוספה',
    added: 'המתנה בסל 🎁'
  } : {
    unlocked: 'Free gift with your blender: Prep Fruit Bags',
    add: 'Add free gift',
    added: 'Your free gift is in the cart 🎁'
  };
  var KEY = 'fm-gift-dismissed';
  function dismissed() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }

  var el = document.createElement('div');
  el.className = 'fm-gift';
  el.setAttribute('role', 'status');
  el.innerHTML = '<div class="fm-gift__text"><span data-t></span></div>' +
    '<button type="button" data-add hidden></button><button type="button" class="fm-gift__x" aria-label="Close" data-x>✕</button>';
  document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(el); refresh(); });

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-x]')) {
      el.classList.remove('is-on');
      try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
    }
    if (e.target.closest('[data-add]')) {
      e.target.disabled = true;
      fetch(prefix + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1 }] })
      }).then(function () { window.location.href = prefix + '/cart'; });
    }
  });

  function refresh() {
    if (dismissed()) return;
    fetch(prefix + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasBlender = false, hasGift = false;
        cart.items.forEach(function (i) {
          if (BLENDERS.indexOf(i.product_id) > -1) hasBlender = true;
          if (i.product_id === GIFT_PRODUCT) hasGift = true;
        });
        if (!hasBlender) { el.classList.remove('is-on'); return; }
        var t = el.querySelector('[data-t]'), add = el.querySelector('[data-add]');
        t.textContent = hasGift ? T.added : T.unlocked;
        add.hidden = hasGift; add.textContent = T.add;
        el.classList.add('is-on');
      }).catch(function () {});
  }

  document.addEventListener('cart:update', function () { setTimeout(refresh, 300); });

  /* Hebrew label for the existing "Buy now" buttons */
  if (he) {
    var fix = function () { document.querySelectorAll('.fm-buynow').forEach(function (b) { if (b.textContent !== 'קנייה מהירה') b.textContent = 'קנייה מהירה'; }); };
    document.addEventListener('DOMContentLoaded', function () {
      fix();
      new MutationObserver(function () { fix(); }).observe(document.body, { childList: true, subtree: true });
    });
  }
})();
